// @flow
import * as React from 'react';

import clsx from 'clsx';

import styles from './CellRowGroup.scss';

/**
 * A `CellRow` wrapper aimed at enforcing responsiness decisions.
 * All CellRows inside his wrapper will be "vertically" distributed on small screens,
 * and horizontally on larger ones.
 * Aka `flex-direction: column | row`.
 */
type Props = {
  children: React.Node,
  className?: string,
  ...
};

const CellRowGroup = ({
  children,
  className,
  ...extraProps
}: Props): React.MixedElement => (
  // $FlowFixMe[cannot-spread-inexact]
  <span className={clsx(styles.root, className)} {...extraProps}>
    {children}
  </span>
);

export default CellRowGroup;
